import React, { Component } from "react"
import { inject, observer } from "mobx-react"
import { Row, Col, Grid } from "react-styled-flexboxgrid"
import styled from "styled-components"

import { withRouter } from "next/router"
import WinItButton from "~/components/WinItButton"
import Spacer from "~/components/Spacer"
import TABLE_SIZES from "./Grid/outterTableSizesRow"
import OtherPersonalInfo from "./OtherPersonalInfo"
import { SEARCH_OPTIONS_COMPONENTS, SEARCH_OPTIONS } from "./Elements/searchConfig"
import PlateNumberAndLicenseState from "./Elements/PlateNumberAndLicenseState"
import CourtSelector from "./Elements/CourtSelector"

import withTranslations from "~/components/_hocs/withTranslations"

// Nassau tabs are rendered in landing/index.jsx above UserInfoInputs
const Form = styled.form`
  -webkit-appearance: none;
  height: 100%;
  width: 100%;
`

const ButtonDiv = styled.div`
  height: 52px;
  ${(props) => props.theme.media.smallDesktop`
    display: none;
  `}
`

@inject((all) => ({
  licenseState: all.store.trafficLookup.licenseState,
  setLicenseState: all.store.trafficLookup.setLicenseState,
  trafficStates: all.store.trafficLookup.trafficStates,
  isMobile: all.store.ui.isMobile,
  columnOne: all.store.trafficLookup.columnOne,
  columnTwo: all.store.trafficLookup.columnTwo,
  columnThree: all.store.trafficLookup.columnThree,
  getFetcherTickets: all.store.trafficLookup.getFetcherTickets,
  searchUsingOtherInfo: all.store.trafficLookup.searchUsingOtherInfo,
  isNYSLicense: all.store.trafficLookup.isNYSLicense,
  fetcherName: all.store.trafficLookup.fetcherName,
  nassauSearchTab: all.store.trafficLookup.nassauSearchTab,
}))
@observer
class SearchFormContainer extends Component {
  constructor() {
    super()
    this.submitButtonRef = React.createRef()
  }

  handleFormSubmit = async (e) => {
    e.preventDefault()

    // Adapted for use w/ parking flow success page
    let flowType = "traffic"
    if (this.props.router.pathname.includes("/parking/flow")) {
      flowType = "parking"
    }
    await this.props.getFetcherTickets(flowType)
  }

  buildOptions = () => {
    const { trafficStates } = this.props

    return trafficStates
      .slice()
      .sort((a, b) => {
        if (a.longName < b.longName) {
          return -1
        }
        if (a.longName > b.longName) {
          return 1
        }
        return 0
      })
      .map((state) => ({
        value: state.shortName,
        label: state.longName,
      }))
  }

  render() {
    const ColumnOneComponent = SEARCH_OPTIONS_COMPONENTS[this.props.columnOne]
    const ColumnTwoComponent = SEARCH_OPTIONS_COMPONENTS[this.props.columnTwo]
    const ColumnThreeComponent = this.props.columnThree ? SEARCH_OPTIONS_COMPONENTS[this.props.columnThree] : null
    const DOBComponent = SEARCH_OPTIONS_COMPONENTS[SEARCH_OPTIONS.DOB]
    const PlateNumberComponent = SEARCH_OPTIONS_COMPONENTS[SEARCH_OPTIONS.PlateNumber]
    const LicenseStateComponent = SEARCH_OPTIONS_COMPONENTS[SEARCH_OPTIONS.licenseState]
    const NassauLicenseComponent = SEARCH_OPTIONS_COMPONENTS[SEARCH_OPTIONS.NassauLicenseId]
    const isNassau = this.props.fetcherName === 'NY_NASSAU'

    return (
      <Form onSubmit={this.handleFormSubmit}>
        <Row>
          <Col {...TABLE_SIZES.inputs}>
            <Grid style={{ width: "100%" }}>
              {isNassau && this.props.nassauSearchTab === 'license' ? (
                <Row>
                  <Col xs={16}>
                    <Spacer mobile={15} desktop={15} />
                    <NassauLicenseComponent submitButtonRef={this.submitButtonRef} />
                  </Col>
                </Row>
              ) : (
              <Row>
                <Col {...TABLE_SIZES.inputColumn}>
                  <Spacer mobile={15} desktop={15} />
                  {ColumnThreeComponent ? (
                    <ColumnOneComponent submitButtonRef={this.submitButtonRef} hideDOB={this.props.columnThree === SEARCH_OPTIONS.DOBPlateNumberAndLicenseState} />
                  ) : (
                    <ColumnOneComponent submitButtonRef={this.submitButtonRef} />
                  )}
                </Col>
                <Col {...TABLE_SIZES.inputColumn}>
                  <Spacer mobile={16} desktop={15} />
                  <ColumnTwoComponent />
                </Col>
                {ColumnThreeComponent && this.props.columnThree === SEARCH_OPTIONS.DOBPlateNumberAndLicenseState ? (
                  <>
                    <Col lg={5} md={5} sm={5} xs={16}>
                      <Spacer mobile={16} desktop={15} />
                      <DOBComponent />
                    </Col>
                    <Col lg={5} md={5} sm={5} xs={16}>
                      <Spacer mobile={16} desktop={15} />
                      <PlateNumberComponent />
                    </Col>
                    <Col lg={6} md={6} sm={6} xs={16}>
                      <Spacer mobile={16} desktop={15} />
                      <LicenseStateComponent />
                    </Col>
                  </>
                ) : ColumnThreeComponent && 
                  !(this.props.columnThree === SEARCH_OPTIONS.PlateNumberAndLicenseState && 
                    !this.props.isNYSLicense && 
                    this.props.columnOne === SEARCH_OPTIONS.nameDOBGender && 
                    this.props.fetcherName === 'NY_STATE') ? (
                      <Col lg={16} md={16} sm={16} xs={16}>
                        <Spacer mobile={16} desktop={15} />
                        <ColumnThreeComponent />
                      </Col>
                ) : null}
              </Row>
              )}

              {/* When isNYSLicense is false and columnOne is nameDOBGender, render PlateNumber and LicenseState in same row as Gender/DOB, under Ticket Number */}
              {!this.props.isNYSLicense && 
               this.props.columnOne === SEARCH_OPTIONS.nameDOBGender && 
               this.props.columnThree === SEARCH_OPTIONS.PlateNumberAndLicenseState && 
               this.props.fetcherName === 'NY_STATE' ? (
                 <>
                   <Spacer mobile={20} desktop={26} />
                   <PlateNumberAndLicenseState />
                 </>
              ) : null}

              {this.props.fetcherName === 'VA' && (
                <Row>
                  <Col xs={16}>
                    <Spacer mobile={15} desktop={15} />
                    <CourtSelector />
                  </Col>
                </Row>
              )}

              {this.props.searchUsingOtherInfo ||
              !this.props.isNYSLicense ||
              this.props.fetcherName === 'NY_NASSAU' ||
              this.props.fetcherName === 'NY_HEMPSTEAD' ||
              this.props.fetcherName === 'NY_SUFFOLK' ? (
                <Spacer mobile={20} desktop={26} />
              ) : (
                <Row>
                  <Col {...TABLE_SIZES.personalInfo}>
                    <Spacer mobile={10} desktop={26} />
                    <OtherPersonalInfo />
                    <Spacer mobile={10} desktop={26} />
                  </Col>
                </Row>
              )}
            </Grid>
          </Col>

          <Col {...TABLE_SIZES.button}>
            <ButtonDiv />
            <WinItButton
              isMobile={this.props.isMobile}
              width="100%"
              height={70}
              maxWidth={this.props.isMobile ? "none" : "170px"}
              style={{ fontSize: "1rem" }}
              type="submit"
              onClick={this.handleFormSubmit}
              ref={this.submitButtonRef}
            >
              {this.props.translate("submit.searchTickets")}
            </WinItButton>
          </Col>
          <Col {...TABLE_SIZES.nothing} />
        </Row>
      </Form>
    )
  }
}

export default withRouter(withTranslations(SearchFormContainer, "form.general"))
